module.exports = __webpack_public_path__ + "img/cancel-icon.12f43c1c.svg";